import "dayjs/locale/ja"; // 日本語ロケールをインポート

import { ThemeProvider } from "@emotion/react";
import { Box, createTheme } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { isMobile } from "react-device-detect";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { persistor, store } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from 'react-redux';
import { AppRoutes } from "./routes/AppRoutes";


function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#2D2E31",
        contrastText: "#fff",
      },
      background: {
        default: "#F5F5F5",
      },
    },
    typography: {
      fontFamily: [
        "Roboto",
        '"Noto Sans JP"',
        '"Helvetica"',
        "Arial",
        "sans-serif",
      ].join(","),
    },
  });


  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="ja"
            dateFormats={{
              year: "YYYY年",
              month: "MM月",
              shortDate: "YYYY/MM/DD",
              fullDate: "YYYY/MM/DD HH:mm",
            }}
          >
            <AppRoutes />
          </LocalizationProvider>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
